export const filterEmptyValues = <T>(data: { [key: string]: string | undefined }) => {
  return Object.fromEntries(Object.entries(data).filter(([_, value]) => value && value !== "")) as T;
};
